<template>    
<v-container grid-list-sm class="pa-4 white">
    <v-layout row wrap>
        <v-flex xs12 sm5 md5 lg5 xl5>
            <template>
                <v-select v-model="idpol" :items="POL" label="Pol"></v-select>
            </template>
        </v-flex>
        <v-flex xs12 sm5 md5 lg5 xl5>
            <template>
                <v-select v-model="idpod" :items="POD" label="Pod"></v-select>
            </template>
        </v-flex>
        <v-flex xs12 sm2 md2 lg2 xl2  class="pa-4">
            <template>
                <v-btn @click="buscarCodigo()"><v-icon>search</v-icon>Search</v-btn>
            </template>
        </v-flex>
    </v-layout>
    <v-layout row wrap>
    <!--    <v-flex xs12 sm10 md10 lg10 xl10>
        <template>
                <div class="container">
                    <div class="large-12 medium-12 small-12 cell">
                    <label>File
                        <input type="file" id="file" ref="file" v-on:change="handleFileUpload()"/>
                    </label>
                    <button v-on:click="submitFile()">Submit</button>
                    </div>
                </div>
            </template>          
        </v-flex>
        <v-flex xs2 sm2 md2 lg2 xl2 class="pa-4">
            <template>
                <v-btn @click="eniviarurl()" text>Cargar<v-icon>arrow_upward</v-icon></v-btn>
            </template>
        </v-flex>   -->
        <v-flex xs12 sm12 md12 lg12 xl12>
            <v-data-table
            :headers="headers"
            :items="tarifas"
            :search="search"
            class="elevation-1" 
            v-if="verNuevo==0"          
            >
            <template v-slot:item.activo="{ item }">
            <div v-if="item.activo">
            <span class="blue--text">Aceptado</span>          
            </div>
            <div v-else>
            <span class="red--text">{{item.activo}}</span>
            </div>
            </template>
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Tarifas</v-toolbar-title>
                    <v-divider
                    class="mx-4"
                    inset
                    vertical
                    ></v-divider>
                    <v-spacer></v-spacer>
                    <v-text-field v-if="verNuevo==0" class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn v-if="verNuevo==0" @click="mostrarNuevo()" color="primary" dark class="mb-2" >Nuevo</v-btn>                        
                </v-toolbar>
            </template>
            <template v-slot:item.opciones="{ item }">
                <v-icon
                small
                class="mr-2"
                @click="verDetalles(item)"
                >
                tab
                </v-icon>
                <template v-if="item.activo">
                    <v-icon
                        small
                        @click="activarDesactivarMostrar(2,item)"
                        >
                        block
                    </v-icon>
                </template>
                <template v-else>
                    <v-icon
                        small
                        @click="activarDesactivarMostrar(1,item)"
                        >
                        check
                    </v-icon>
                </template>
            </template>
                <template slot="no-data">
                    <v-btn colo="primary" @click="buscarCodigo()">Resetear</v-btn>
                </template> 
            </v-data-table> 
        </v-flex>        
    </v-layout>
</v-container>
</template>
<script>
import axios from 'axios'
export default {
    data(){
        return{
             file: '',
             tarifas:[],
             headers: [
                { text: 'Opciones', value: 'opciones', sortable: false },
                { text: 'Proveedor', value: 'nombreprov' },
                { text: 'POL', value: 'pol', },
                { text: 'POD', value: 'pod' },
              //  { text: 'Frecuencia', value: 'frecuencia', sortable: false },
              //  { text: 'Tiempo Transito', value: 'tt', sortable: false  },
               // { text: 'Ruta', value: 'serviciodirecto', sortable: false  },
                { text: 'Moneda', value: 'abreviatura', sortable: false  },
                { text: '20DC', value: 'dC20', sortable: false  },
                { text: '20HC', value: 'hC20', sortable: false  },
                { text: '40DC', value: 'dC40', sortable: false  },
                { text: '40HC', value: 'hC40', sortable: false  },
              //  { text: '20DC REEFER', value: 'dcF20', sortable: false  },
               // { text: '20HC REEFER', value: 'hcF2', sortable: false  },
                { text: '40DC REEFER', value: 'dcF40', sortable: false  },
                { text: '40HC REEFER', value: 'hcF40', sortable: false  },
                //{ text: 'Dias Libres Origen', value: 'diaslibres_origen', sortable: false  },
               // { text: 'Dias Libres Destino', value: 'diaslibre_destino', sortable: false  },
               // { text: 'Comentarios', value: 'comentarios', sortable: false  },
               // { text: 'B/L FEE', value: 'blfee', sortable: false  },
               // { text: 'SELLO', value: 'sello', sortable: false  },
                //{ text: 'IMO CARGO', value: 'imocargo', sortable: false  },
                //{ text: 'Acondicionamiento', value: 'acondicionamiento', sortable: false  },
                //{ text: 'Arratre', value: 'arrastre', sortable: false  },
               // { text: 'Estado', value: 'estado', sortable: false  },
                ],
                search:'',
                verNuevo:0,                                
                file: '',
                POL:[],
                POD:[],
                idpod:'',
                idpol:''
        }
    },
    created () {        
       // this.listar();
        this.selectpol();
        this.selectpod();
        
    },
    methods:{  
//////////////////////////////////////////////////////////////////////////
submitFile(){
        /*
                Initialize the form data
            */
            let formData = new FormData();

            /*
                Add the form data we need to submit
            */
            formData.append('file', this.file);

        /*
          Make the request to the POST /single-file URL
        */
            axios.post( '/single-file',
                formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }
            ).then(function(){
          console.log('SUCCESS!!');
        })
        .catch(function(){
          console.log('FAILURE!!');
        });
      },

      /*
        Handles a change on the file upload
      */
      handleFileUpload(){
        this.file = this.$refs.file.files[0];
      },

//////////////////////////////////////////////////////////////////////////
        listar(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            axios.get('api/Tarifas/Listar',configuracion).then(function(response){              
              me.tarifas=response.data;
            }).catch(function(error){
              console.log(error);
            });
        },
        buscarCodigo(){//mandamos llamar el controlador Categorias y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion             
            console.log("pol:" + me.idpol);
            console.log("pod:" + me.idpod);
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};            
            axios.get('api/Tarifas/Mostrar/'+me.idpol+"/"+me.idpod,configuracion).then(function(response){                           
             me.tarifas=response.data;
            }).catch(function(error){
              console.log(error);              
            });
        },        
        eniviarurl(){            
          //  const fd = new FormData();
            //fd.append('xml',this.selectedFile,this.selectedFile.name)
            let formData = new FormData();
            formData.append('file', this.file);

            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            console.log(this.file);
            
            /*axios.post('api/Tarifarios/Crear',{
            "idusuario":3,
            "idproveedor":2,
            "nombrearchivo":this.urltarifario.name,
            "fechavalidez":"2020-02-12T14:10:04.627"},configuracion)
            .then(function(response){
                console.log(response);                
            }).catch(function(error){
                    console.log(error);
                }); */
        },
        onChangeFileUpload(){
            this.file = this.$refs.file.files[0];
        },
     /*   onFileSelected(event){
            this.selectedFile = event.target.files[0];          
             @change="onFileSelected()"   
        },*/
        selectpod(){//mandamos llamar el controlador Puertos y asu accion Listar y guardamos la informacion que nos devuelve en la variable response            
            
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var podArray=[];
            axios.get('api/Puertos/Select',configuracion).then(function(response){              
              podArray=response.data;
              podArray.map(function(x){
                  me.POD.push({text:x.nombre,value:x.idpuerto});
              });            
            }).catch(function(error){
              console.log(error);
            });
        },
        selectpol(){//mandamos llamar el controlador Puertos y asu accion Listar y guardamos la informacion que nos devuelve en la variable response
            let me=this;//this para que pueda ser utilizada en cualquiier llamado de aacion 
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion ={headers:header};
            var polArray=[];
            axios.get('api/Puertos/Select',configuracion).then(function(response){              
              polArray=response.data;
              polArray.map(function(x){
                  me.POL.push({text:x.nombre,value:x.idpuerto});
              });            
            }).catch(function(error){
              console.log(error);
            });
        },
        mostrarNuevo(){
            this.verNuevo=1;
        },
        ocultarNuevo(){
            this.verNuevo=0;
        },
        
    }
}
</script>